module.exports = __webpack_public_path__ + "static/media/Landing-3.74e99d4f.jpg";